/* eslint-disable max-len */

import isPlainObject from 'lodash/isPlainObject';

import React, {
  useState,
  useMemo,
  useEffect,
  useCallback,
} from 'react';
import styled, { css } from 'styled-components';
// import ObjectId from 'bson-objectid';

import { stringify as stringifyQuery } from 'querystring';

import {
  LeftOutlined,
  RightOutlined,
  UploadOutlined,
  CheckOutlined,
} from '@ant-design/icons';

// import AntdRadio from 'antd/lib/radio';
import Tag from 'antd/lib/tag';
import AntdButton from 'antd/lib/button';
import AntdDropdown from 'antd/lib/dropdown';
import AntdMenu from 'antd/lib/menu';
import Descriptions from 'antd/lib/descriptions';

import Admin from 'hive-admin';
// import Form from 'hive-admin/src/components/Form';

import {
  asLocalStorageField,
} from 'hive-admin/src/components/FieldLocalStorage';

// import ReactJsonPrint from 'react-json-print';

import copyToClipboard from '../../helpers/copyToClipboard';

import { fieldI18nLanguage } from '../../helpers/i18n';

// import { createChangeLogSection } from '../../components/FieldChangeLog';

import useQuery from '../../modules/useQuery';

import tests from '../../helpers/tests';

import Types from '../../modules/types';

const {
  viewerIsNotThehiveRsAdmin,
} = tests;

const jsonStringifyReplacerSortObjectKeys = (key, value) => (
  isPlainObject(value)
  ? (
      Object.keys(value)
      .sort()
      .reduce(
        (sorted, sortedKey) => {
          sorted[sortedKey] = value[sortedKey];
          return sorted;
        },
        {},
      )
    )
  : value
);

// const JsonWrapper = styled.div`
//   padding: 4px 0px;
//   padding-top: 8px;
//   > div, > div * {
//     font-size: 12px;
//     font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace;
//     color: ${({ theme }) => theme.less.textColor};
//     .data__key {
//       opacity: 0.5;
//     }
//     .data__type {
//       padding: 2px;
//     }
//   }
// `;

const StatsDescriptions = styled(Descriptions)`
  .ant-descriptions-item-label {
    vertical-align: top;
  }
  td:nth-child(1), th:nth-child(1) {
    white-space: nowrap;
  }
  td:nth-child(2) {
    width: 100%;
  }
  ${({ $align }) => $align === 'right' && css`
    td:nth-child(2), th:nth-child(2) {
      text-align: right;
    }
  `}
`;

// const GalleryItemWrapper = styled.div`
//   display: flex;
//   width: 100%;
// `;

// const GalleryItemFieldWrapper = styled.div`
//   display: flex;
//   .ant-row.ant-form-item {
//     padding-bottom: 0px;
//     margin-bottom: 0px;
//   }
//   &[data-gallery-field-name="image"],&[data-gallery-field-name="video"] {
//     [data-input-name="image"] {
//       padding-left: 0px !important;
//       padding-right: 0px !important;
//     }
//     [data-input-name="video"] {
//       padding-right: 0px !important;
//     }
//     .ant-upload-select-picture-card {
//       margin-right: 0px;
//       margin-bottom: 0px;
//     }
//     .ant-upload-list-picture-card-container {
//       margin: 0px;
//     }
//     .ant-upload-list-picture-card .ant-upload-list-item {
//       margin: 0px;
//     }
//   }
//   &[data-gallery-field-name="variants"] {
//     width: 100%;
//     overflow: hidden;
//     .ant-select-selection {
//       height: 103px;
//     }
//     .ant-select-selection.ant-select-selection--multiple {
//       overflow: scroll;
//     }
//     [data-input-name="variants"] {
//       padding-right: 0px !important;
//     }
//   }
// `;

export const fieldName = ['FieldText', {
  name: 'name',
  rules: [['validation.isRequired']],
  // i18nTranslatable: true,
}];

export const fieldStoreDivider = ['Divider', {
  name: 'storeDivider',
}];

export const fieldVariantsHidden = ['FieldHidden', {
  name: 'variants',
  virtual: [() => true],
}];

export const fieldStore = ['FieldConnectionSelect', {
  name: 'store',
  placeholder: 'Select Store',
  url: '/stores/list',
  // getChoiceLabel: choice => choice.data.name,
  searchPaths: ['name'],
  rules: [['validation.isRequired']],
  disabled: [tests.activityIsNotCreate],
  virtual: [tests.activityIsNotCreate],
}];

export const fieldCsvHeaderNameIndex = ['FieldSelect', {
  name: 'csvHeaderNameIndex',
  label: 'Product Name Column',
  choices: [],
  disabled: [() => true],
  virtual: [() => true],
  renderChoices: (field, props) => {
    const choices = (props?.data?.csv?.headers || []).map(
      (label, i) => ({
        label: `${label} (${i + 1})`,
        value: i,
      }),
    );
    return choices.map(choice => props.renderChoice(choice, field, props));
  },
}];

export const fieldJSON = ['FieldReact', {
  name: 'items',
  disabled: [() => true],
  virtual: [() => true],
  // eslint-disable-next-line arrow-body-style
  renderContent: (props) => {
    return (
      <pre>
        <code>
          {JSON.stringify(props.data, null, '  ')}
        </code>
      </pre>
    );
  },
}];

export const Monospace = styled.span`
  font-family: Menlo;
  font-size: 80%;
  white-space: pre;
`;

export const PaddedMonospace = ({
  length = 0,
  char = ' ',
  children,
  ...props
}) => {
  const padLength = Math.max(0, length - `${children}`.length);
  return (
    <span {...props}>
      <Monospace style={{ opacity: 0.2 }}>
        {new Array(padLength).fill(char).join('')}
      </Monospace>
      <Monospace>
        {children}
      </Monospace>
    </span>
  );
};

export const fieldInfo = ['FieldReact', {
  label: 'Info',
  renderContent: (props) => {
    const {
      status = 'NEW',
      limit = -1,
      stats: {
        count: {
          total = 0,
          done = 0,
          // imported = 0,
          errors = 0,
        } = {},
      } = {},
      galleryCount = 0,
      galleryDirectories = [],
    } = props.data || {};
    return (
      <StatsDescriptions
        size="small"
        column={1}
        bordered
        $align="right"
      >
        <StatsDescriptions.Item
          key="status"
          label="Status"
        >
          <Monospace>
            {`${
              Types.PRODUCTS_IMPORT_STATUS_MAP[status]?.label
              || '-'
            }${
              limit > -1
              ? ` (first ${limit})`
              : ''
            }`}
          </Monospace>
        </StatsDescriptions.Item>
        <StatsDescriptions.Item
          key="progress"
          label="Progress"
        >
          <Monospace>
            {`${
              done
            } / ${
              total
            }${
              errors > 0
              ? ` (${
                  errors
                } ${
                  errors === 1
                  ? 'failed'
                  : 'failed'
                })`
              : ''
            }`}
          </Monospace>
        </StatsDescriptions.Item>
        {/* <StatsDescriptions.Item
          key="gallery"
          label="Generate Gallery"
        >
          <Monospace>
            {gallery}
          </Monospace>
          <Monospace>
            {' / '}
          </Monospace>
          <Monospace>
            {(props.data?.csv?.items || []).length}
          </Monospace>
        </StatsDescriptions.Item> */}
        <StatsDescriptions.Item
          key="gallery"
          label="Gallery"
        >
          <Monospace>
            {`${
              galleryDirectories.length
            } ${
              galleryDirectories.length === 1
              ? 'Directory'
              : 'Directories'
            } / ${
              galleryCount
            } ${
              galleryCount === 1
              ? 'Image'
              : 'Images'
            }`}
          </Monospace>
        </StatsDescriptions.Item>
      </StatsDescriptions>
    );
  },
}];

export const fieldProductsImportGalleryTitle = asLocalStorageField(
  ['FieldTitleToggle', {
    title: 'Import Gallery',
    name: 'productsImportGalleryIsCollapsed',
    // eslint-disable-next-line arrow-body-style
    onChange: (event) => { return (event.nativeEvent.value); },
  }],
);

export const fieldProductsImportGalleryDropzone = ['FieldUploadRefsDropzone', {
  name: 'productsImportGalleryDropzone',
  accept: 'image/jpg,image/jpeg,image/png,image/webp',
  // placeholder: 'Drag and drop a directory with folders containing images for each product',
  getIcon: (props) => {
    if (props.data?.galleryCount > 0) {
      return <CheckOutlined />
    }
    return <UploadOutlined />;
  },
  getPlaceholder: (props) => {
    if (props.data?.galleryCount > 0) {
      return `${props.data?.galleryCount} ${
        props.data?.galleryCount === 1
        ? 'Image'
        : 'Images'
      } Uploaded!`;
    }
    return 'Drag and drop a directory with folders containing images for each product';
  },
  hidden: [
    [
      'condition.fieldIsNotTrue',
      'productsImportGalleryIsCollapsed',
    ],
  ],
  disabled: [
    props => props.data?.status !== 'NEW' || props.data?.galleryCount > 0,
  ],
  transformations: [
    ['GM', { command: 'compress', maxWidth: 2000 }],
    ['GM', { command: 'webp' }],
  ],
  style: { marginBottom: '10px' },
  virtual: [() => true],
  getUploadArgs: (args, props) => {
    args.tag = props.data?.galleryTag;
    return args;
  },
  // eslint-disable-next-line no-unused-vars
  onUploadSuccess: async (uploads, props) => {
    Admin.showMessage(
      'Images uploaded successfully!',
      'success',
      3,
    );
    props.reload();
  },
}];

function ImageUploader(props) {
  const { history, searchParams } = props;
  const itemIndex = parseInt(searchParams.index, 10) || 0;
  const [productJsonIsOpen, setProductJsonIsOpen] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [{ loading, data: response }, reload] = useQuery(props.client, {
    url: `products-imports/${
      props.match.params.id
    }/prepare/${
      itemIndex
    }?query=${encodeURIComponent(JSON.stringify({
      includeGallery: true,
    }))}`,
  });
  const itemId = useMemo(
    () => {
      if (props.data.csv?.items?.length) {
        const { _id: newItemId } = props.data.csv.items[itemIndex] || {};
        return newItemId;
      }
      return null;
    },
    [itemIndex, props.data?.csv?.items],
  );
  const setItemIndex = useCallback(
    (newItemIndex) => {
      history.replace({
        search: stringifyQuery({ ...searchParams, index: newItemIndex }),
      });
    },
    [history, searchParams],
  );
  const { data } = response || {};
  const {
    data: {
      product: productData,
    } = {},
  } = response || {};
  const { gallery: productGallery } = productData || {};
  const [gallery, setGallery] = useState([]);
  useEffect(
    () => {
      setGallery(productGallery || []);
    },
    [itemIndex, productGallery],
  );
  // const fieldProductGalleryTitle = useMemo(
  //   () => Admin.compileFromLibrary(['FieldTitle', {
  //     title: 'Product Gallery',
  //     size: 'medium',
  //     style: { marginBottom: '10px' },
  //   }]),
  //   [],
  // );
  // const fieldProductGalleryUploader = useMemo(
  //   () => Admin.compileFromLibrary(
  //     ['FieldUploadRefsDropzone', {
  //       name: 'productGalleryDropzone',
  //       accept: 'image/jpg,image/jpeg,image/png,image/webp',
  //       placeholder: 'Drag and drop folder with product images',
  //       transformations: [
  //         ['GM', { command: 'compress', maxWidth: 2000 }],
  //       ],
  //       style: { marginBottom: '10px' },
  //       virtual: [() => true],
  //       // eslint-disable-next-line arrow-body-style
  //       onUploadSuccess: async (uploads, localProps) => {
  //         try {
  //           const {
  //             productVariants,
  //           } = (
  //             (productData?.variants || [])
  //             .reduce(
  //               (agr, item) => {
  //                 const newItem = {
  //                   label: item.label,
  //                   options: (item.choices || []).map(choice => ({
  //                     label: choice.label,
  //                     value: choice._id,
  //                   })),
  //                 };
  //                 agr.productVariants.push(newItem);
  //                 return agr;
  //               },
  //               {
  //                 productVariants: [],
  //               },
  //             )
  //           );
  //           const productShippingCategory = productData?.shippingCategory;
  //           const uploadsPathToVariantChoiceIdMap = await (
  //             localProps.client.request({
  //               url: '/products/gallery-generate',
  //               method: 'POST',
  //               data: {
  //                 productName: productData?.name,
  //                 productShippingCategory,
  //                 productVariants,
  //                 paths: uploads.map(upload => upload.meta.filepath),
  //                 store: productData?.store || null,
  //               },
  //             })
  //             .then(res => res.data)
  //             .catch(error => {
  //               // eslint-disable-next-line no-console
  //               console.log('error:', error);
  //             })
  //           );
  //           const newGallery = [
  //             ...(uploads || []).map((upload) => {
  //               const variantIds = uploadsPathToVariantChoiceIdMap[
  //                 upload.meta.filepath
  //               ];
  //               return {
  //                 _id: `${ObjectId()}`,
  //                 video: null,
  //                 image: upload,
  //                 variants: variantIds,
  //                 categories: [],
  //               };
  //             }),
  //             ...gallery,
  //           ];
  //           setGallery(newGallery);
  //           // props.form.setFields({
  //           //   gallery: {
  //           //     value: newGallery,
  //           //     touched: true,
  //           //   },
  //           // });
  //         } catch (error) {
  //           // eslint-disable-next-line no-console
  //           console.log('error:', error);
  //         }
  //       },
  //     }],
  //   ),
  //   [
  //     productData,
  //     gallery,
  //     // props.form,
  //   ],
  // );
  // const fieldProductGallery = useMemo(
  //   () => Admin.compileFromLibrary(['FieldSortableList', {
  //     name: 'gallery',
  //     // label: 'Gallery',
  //     label: null,
  //     addButtonChoices: [],
  //     addButtonLabel: 'Add Gallery Item',
  //     supportRemoveAll: true,
  //     skip: [],
  //     FormComponent: class GalleryItemForm extends Form {
  //       renderField(field, style = {}) {
  //         return (
  //           <GalleryItemFieldWrapper
  //             key={field.name}
  //             data-gallery-field-name={field.name}
  //             style={style}
  //           >
  //             {super.renderField(field)}
  //           </GalleryItemFieldWrapper>
  //         );
  //       }

  //       // eslint-disable-next-line no-unused-vars
  //       renderFields(fields) {
  //         // eslint-disable-next-line react/no-this-in-sfc
  //         const { fieldsMap } = this.state.props;
  //         return (
  //           <GalleryItemWrapper key="itemFields">
  //             {/* eslint-disable-next-line react/no-this-in-sfc */}
  //             {this.renderField(fieldsMap.image, {
  //             })}
  //             {/* eslint-disable-next-line react/no-this-in-sfc */}
  //             {this.renderField(fieldsMap.video, {
  //             })}
  //             {/* eslint-disable-next-line react/no-this-in-sfc */}
  //             {this.renderField(fieldsMap.variants, {
  //             })}
  //           </GalleryItemWrapper>
  //         );
  //       }
  //     },
  //     condensed: true,
  //     fields: [
  //       ['FieldUploadRefs', {
  //         name: 'image',
  //         label: null,
  //         maxCount: 1,
  //         listType: 'picture-card',
  //         uploadLabel: 'Image',
  //         // rules: [['validation.isRequired']],
  //         accept:
  //           'image/jpg,image/jpeg,image/png,image/webp',
  //         transformations: [
  //           ['GM', { command: 'compress', maxWidth: 2000 }],
  //         ],
  //         getUploadArguments: localProps => ({
  //           transformations: localProps.getTransformations(localProps),
  //           tag: props.data?.galleryTag,
  //         }),
  //       }],
  //       ['FieldUploadRefs', {
  //         name: 'video',
  //         label: null,
  //         maxCount: 1,
  //         listType: 'picture-card',
  //         uploadLabel: 'Video',
  //         // rules: [['validation.isRequired']],
  //         accept: 'video/mp4,video/webm',
  //       }],
  //       ['FieldSelect', {
  //         name: 'variants',
  //         label: null,
  //         placeholder: 'Options this gallery item applies to',
  //         mode: 'multiple',
  //         choices: [],
  //         renderChoices: (field, choicesProps) => {
  //           // const form = choicesProps.forms[choicesProps.forms.length - 1];
  //           // const data = choicesProps.datas[choicesProps.datas.length - 1];
  //           // const variants = (
  //           //   form?.getFieldValue?.('variants')
  //           //   || data?.variants
  //           //   || []
  //           // );
  //           const variants = choicesProps.dataVariants || [];
  //           return variants.reduce(
  //             (agr, variant) => {
  //               if (variant.choices?.length) {
  //                 variant.choices.forEach((choice) => {
  //                   agr.push(choicesProps.renderChoice({
  //                     value: `${choice._id}`,
  //                     label: `${variant.label}: ${choice.label}`,
  //                   }, field, choicesProps));
  //                 })
  //               }
  //               return agr;
  //             },
  //             [],
  //           );
  //         },
  //       }],
  //     ],
  //   }]),
  //   [props.data?.galleryTag],
  // );
  const fieldStats = useMemo(
    () => Admin.compileFromLibrary(['FieldReact', {
      label: null,
      // eslint-disable-next-line no-unused-vars, no-shadow, arrow-body-style
      renderContent: (props) => {
        return (
          <StatsDescriptions
            size="small"
            column={1}
            bordered
          >
            <StatsDescriptions.Item
              key="productName"
              label="Name"
            >
              {props.productName || '-'}
            </StatsDescriptions.Item>
            <StatsDescriptions.Item
              key="productErrors"
              label="Notes"
            >
              {
                props.productErrors?.length
                ? (
                    (props.productErrors).map(error => (
                      <Tag key={error}>
                        <span style={{ textTransform: 'capitalize' }}>
                          {error}
                        </span>
                      </Tag>
                    ))
                  )
                : '-'
              }
            </StatsDescriptions.Item>
            <StatsDescriptions.Item
              key="itemError"
              label="Error"
            >
              {
                props.item?.stats?.error
                ? props.item?.stats?.error?.message
                : '-'
              }
            </StatsDescriptions.Item>
            <StatsDescriptions.Item
              key="preview"
              label="Preview"
            >
              <div>
                {
                  props.product
                  ? (
                      <>
                        <Tag
                          style={{ cursor: 'pointer' }}
                          onClick={() => props.setProductJsonIsOpen(
                            !props.productJsonIsOpen
                          )}
                        >
                          {
                            props.productJsonIsOpen
                            ? 'Hide Product JSON'
                            : 'Show Product JSON'
                          }
                        </Tag>
                        <Tag
                          style={{ cursor: 'pointer' }}
                          onClick={() => copyToClipboard(
                            JSON.stringify(props.product, null, '  '),
                          )}
                        >
                          Copy To Clipboard
                        </Tag>
                      </>
                    )
                  : null
                }
                {
                  props.productJsonIsOpen
                  ? (
                      // <JsonWrapper>
                      //   <ReactJsonPrint
                      //     dataObject={props.product || null}
                      //   />
                      // </JsonWrapper>
                      <pre
                        style={{
                          padding: '4px 0px',
                          marginBottom: '0px',
                          whiteSpace: 'pre-wrap',
                        }}
                      >
                        <code style={{ fontSize: '76%' }}>
                          {
                            JSON.stringify(
                              {
                                ...props.product,
                                gallery: props.newGallery,
                              },
                              jsonStringifyReplacerSortObjectKeys,
                              '  ',
                            )
                          }
                        </code>
                      </pre>
                    )
                  : null
                }
              </div>
            </StatsDescriptions.Item>
          </StatsDescriptions>
        );
      },
      style: {
        marginTop: '-30px',
      },
    }]),
    [],
  );
  // const actionCreateProduct = useMemo(
  //   () => Admin.compileFromLibrary(['ActionWithRequest', {
  //     name: 'action-create',
  //     title: 'Create',
  //     skip: [],
  //     getRequestConfig: (actionProps) => {
  //       const requestConfig = {
  //         url: 'products',
  //         method: 'POST',
  //         data: {
  //           ...actionProps.newProductData,
  //           gallery: actionProps.newGallery,
  //           importId: actionProps.newProductsImportId,
  //           importItemId: actionProps.newProductsImportItemId,
  //         },
  //       };
  //       return requestConfig;
  //     },
  //     getMessageSuccess: (responseData) => `Created: /products/${
  //       responseData._id
  //     }`,
  //   }]),
  //   [],
  // );
  // const actionSaveRow = useMemo(
  //   () => Admin.compileFromLibrary(['ActionWithRequest', {
  //     name: 'action-save',
  //     title: 'Save',
  //     getRequestConfig: (actionProps) => ({
  //       url: `products-upload-batch/${
  //         actionProps.newProductsImportId
  //       }/save/${
  //         actionProps.newProductsImportItemIndex
  //       }`,
  //       data: {
  //         galleryItems: actionProps.newGallery || [],
  //       },
  //       method: 'PATCH',
  //     }),
  //     messageSuccess: 'Saved!',
  //   }]),
  //   [],
  // );
  // const actionResetRow = useMemo(
  //   () => Admin.compileFromLibrary(['ActionWithRequest', {
  //     name: 'action-reset',
  //     title: 'Reset',
  //     getRequestConfig: (actionProps) => ({
  //       url: `products-imports/${
  //         actionProps.newProductsImportId
  //       }/reset/${
  //         actionProps.newProductsImportItemIndex
  //       }`,
  //       method: 'POST',
  //     }),
  //     messageSuccess: 'Reset Success!',
  //   }]),
  //   [],
  // );
  // const actionResetRowGallery = useMemo(
  //   () => Admin.compileFromLibrary(['ActionWithRequest', {
  //     name: 'action-reset-gallery',
  //     title: 'Reset Gallery',
  //     getRequestConfig: (actionProps) => ({
  //       url: `products-imports/${
  //         actionProps.newProductsImportId
  //       }/reset/${
  //         actionProps.newProductsImportItemIndex
  //       }/gallery`,
  //       method: 'POST',
  //     }),
  //     messageSuccess: 'Reset Gallery Success!',
  //   }]),
  //   [],
  // );
  // const actionDeleteProduct = useMemo(
  //   () => Admin.compileFromLibrary(['ActionWithRequest', {
  //     name: 'action-delete-product',
  //     title: 'Delete Product',
  //     getRequestConfig: (actionProps) => ({
  //       url: `products-imports/${
  //         actionProps.newProductsImportId
  //       }/delete-products/${
  //         actionProps.newProductsImportItemIndex
  //       }`,
  //       method: 'POST',
  //     }),
  //     messageSuccess: 'Product Deleted!',
  //   }]),
  //   [],
  // );
  const header = (
    <div style={{ width: '100%' }}>
      <div
        style={{
          display: 'flex',
          gap: '10px',
          paddingBottom: '16px',
          width: '100%',
        }}
      >
        <AntdButton.Group
          style={{
            display: 'flex',
            width: '100%',
          }}
        >
          <AntdButton
            onClick={() => setItemIndex(Math.max(0, itemIndex - 1))}
            style={{ flex: 1 }}
          >
            <LeftOutlined />
          </AntdButton>
          <AntdDropdown
            overlay={(
              <AntdMenu
                style={{
                  maxHeight: '300px',
                  overflowY: 'scroll',
                }}
              >
                {
                  (props.data?.csv?.items || []).map(item => (
                    <AntdMenu.Item
                      key={item._id}
                      onClick={event => setItemIndex(event.item.props.index)}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: '10px',
                        flexWrap: 'wrap',
                      }}
                    >
                      <span>
                        {`Product: ${item?.index + 1}`}
                      </span>
                      <span
                        style={{
                          display: 'flex',
                          marginRight: '-10px',
                          flexWrap: 'wrap',
                        }}
                      >
                        {
                          [
                            [
                              'gallery-generated',
                              item.gallery?.generated ? 'Has Gallery' : null,
                            ],
                          ].map(([key, label]) => (
                            label
                            ? (
                                <Tag
                                  key={key}
                                  size="small"
                                  style={{
                                    transform: 'translateY(-1px)',
                                  }}
                                >
                                  {label}
                                </Tag>
                              )
                            : null
                          ))
                        }
                      </span>
                    </AntdMenu.Item>
                  ))
                }
              </AntdMenu>
            )}
          >
            <AntdButton
              style={{ flex: 1, width: '100%' }}
            >
              {`Product: ${itemIndex + 1}`}
            </AntdButton>
          </AntdDropdown>
          <AntdButton
            onClick={() => setItemIndex(
              Math.min((props.data?.csv?.items?.length || 1) - 1, itemIndex + 1)
            )}
            style={{ flex: 1 }}
          >
            <RightOutlined />
          </AntdButton>
        </AntdButton.Group>
      </div>
      {
        fieldStats.render({
          product: data?.product || null,
          productName: productData?.name || null,
          productError: data?.error || null,
          productErrors: data?.errors ? data.errors : [],
          productJsonIsOpen,
          setProductJsonIsOpen,
          newGallery: gallery,
        })
      }
      <div style={{ height: '15px' }} />
    </div>
  );
  if (!productData || !itemId) {
    return (
      <>
        {header}
        {/* <div style={{ display: 'flex', gap: '12px' }}>
          {actionResetRow.render({
            viewer: props.viewer,
            client: props.client,
            newProductsImportId: props.match.params.id,
            newProductsImportItemIndex: itemIndex,
          })}
          {actionResetRowGallery.render({
            viewer: props.viewer,
            client: props.client,
            newProductsImportId: props.match.params.id,
            newProductsImportItemIndex: itemIndex,
          })}
        </div> */}
      </>
    );
  }
  return (
    <>
      {header}
      <div style={{ paddingBottom: '16px' }}>
        {/* {fieldProductGalleryTitle.render({
          viewer: props.viewer,
          client: props.client,
          value: gallery,
          data: props.data,
          form: props.form,
        })} */}
        {/* {fieldProductGalleryUploader.render({
          viewer: props.viewer,
          client: props.client,
          value: gallery,
          data: props.data,
          form: props.form,
          // onChange: value => setGallery(value),
          dataProduct: productData,
          dataStore: productData?.store,
          dataName: productData?.name,
          dataVariants: productData?.variants,
          dataShippingCategory: productData?.shippingCategory,
        })} */}
        {/* {fieldProductGallery.render({
          viewer: props.viewer,
          client: props.client,
          value: gallery,
          data: props.data,
          form: props.form,
          onChange: value => setGallery(value),
          dataProduct: productData,
          dataStore: productData?.store,
          dataName: productData?.name,
          dataVariants: productData?.variants,
          dataShippingCategory: productData?.shippingCategory,
        })} */}
      </div>
      {/* <div style={{ display: 'flex', gap: '12px' }}>
        {actionCreateProduct.render({
          viewer: props.viewer,
          client: props.client,
          newGallery: gallery,
          newProductData: productData,
          newProductsImportId: props.match.params.id,
          newProductsImportItemId: itemId,
          newProductsImportItemIndex: itemIndex,
        })}
        {actionSaveRow.render({
          viewer: props.viewer,
          client: props.client,
          newGallery: gallery,
          newProductData: productData,
          newProductsImportId: props.match.params.id,
          newProductsImportItemId: itemId,
          newProductsImportItemIndex: itemIndex,
        })}
        {actionResetRow.render({
          viewer: props.viewer,
          client: props.client,
          newProductsImportId: props.match.params.id,
          newProductsImportItemId: itemId,
          newProductsImportItemIndex: itemIndex,
        })}
        {actionResetRowGallery.render({
          viewer: props.viewer,
          client: props.client,
          newProductsImportId: props.match.params.id,
          newProductsImportItemId: itemId,
          newProductsImportItemIndex: itemIndex,
        })}
        {actionDeleteProduct.render({
          viewer: props.viewer,
          client: props.client,
          newGallery: gallery,
          newProductData: productData,
          newProductsImportId: props.match.params.id,
          newProductsImportItemIndex: itemIndex,
        })}
      </div> */}
    </>
  );
}

export const fieldProductsImportResultsInspectorTitle = asLocalStorageField(['FieldTitleToggle', {
  name: 'ProductsImportResultsIsCollapsed',
  getTitle: () => 'Products',
  // getSubtitle: (subtitle, localProps) => (
  //   <div>
  //     {`Current: ${
  //       localProps.productName || '-'
  //     }`}
  //     {localProps.productErrors}
  //   </div>
  // ),
}]);

export const fieldProductsImportResultsInspector = ['FieldReact', {
  name: 'ProductsImportResultsInspector',
  virtual: [() => true],
  hidden: [
    [
      'condition.fieldIsNotTrue',
      'ProductsImportResultsIsCollapsed',
    ],
  ],
  // eslint-disable-next-line arrow-body-style
  renderContent: (props) => {
    return (
      <ImageUploader {...props} />
    );
  },
}];

export const fieldPromptTitle = asLocalStorageField(['FieldTitleToggle', {
  title: 'Prompt',
  name: 'promptIsCollapsed',
  hidden: [
    viewerIsNotThehiveRsAdmin,
  ],
}]);

export const fieldPrompt = ['FieldTextArea', {
  name: 'prompt',
  label: null,
  // eslint-disable-next-line max-len
  placeholder: 'Prompt template for AI (save as empty in order to reset to default)',
  autoSize: { minRows: 3 },
  fontFamily: 'Menlo',
  fontSize: '80%',
  hidden: [
    viewerIsNotThehiveRsAdmin,
    [
      'condition.fieldIsNotTrue',
      'promptIsCollapsed',
    ],
  ],
}];

export const ADMIN = [
  fieldI18nLanguage,
  fieldName,
  fieldStore,
  fieldCsvHeaderNameIndex,
  fieldInfo,
  fieldProductsImportGalleryTitle,
  fieldProductsImportGalleryDropzone,
  fieldVariantsHidden,
  fieldProductsImportResultsInspectorTitle,
  fieldProductsImportResultsInspector,
  fieldPromptTitle,
  fieldPrompt,
  // fieldJSON,
  // ...createChangeLogSection({
  //   changeLogConfig: {
  //     getWhereConditions: props => ({
  //       store: props.data?.store,
  //       'target.type': 'Document',
  //       'target.subject': props.data._id,
  //     }),
  //     skipColumns: {
  //       store: true,
  //       realm: true,
  //       target: true,
  //     },
  //   },
  // }),
];

export const SELLER = [
  fieldI18nLanguage,
  fieldName,
  fieldCsvHeaderNameIndex,
  fieldInfo,
  fieldProductsImportGalleryTitle,
  fieldProductsImportGalleryDropzone,
  fieldPromptTitle,
  fieldPrompt,
  // fieldJSON,
];
